/**
 * Adapptio Core library.
 *
 * @package lib-core
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import { Type } from "@adapptio/lib-blueprint";
import { NODE_OUTPUT_NAMES, TAllNodesSpec, TBlueprintRequestNodeOptsSchemaSpec } from "../../blueprints";
import { IActionContext, INodeContext, INodeResult } from "../ActionManager";
import { createSuccessNodeResult } from "../helpers";

export async function requestNodeHandler<TSpec extends Partial<TAllNodesSpec>>(
	opts: TBlueprintRequestNodeOptsSchemaSpec,
	aCtx: IActionContext<TSpec>,
	nCtx: INodeContext
): Promise<INodeResult> {
	const { request } = aCtx.context;

	return createSuccessNodeResult(
		{
			opts,
			outputName: NODE_OUTPUT_NAMES.ON_REQUEST,
			typeDescriptor: Type.Object({
				props: {
					path: Type.String({}),
					query: Type.Map({
						items: { "[K: string]": Type.Any({}) }
					}),
					headers: Type.Map({
						items: { "[K: string]": Type.String({}) }
					}),
					params: Type.Map({
						items: { "[K: string]": Type.String({}) }
					}),
					body: Type.Any({})
				}
			}),
			data: (request as any) || {}
		},
		aCtx,
		nCtx
	);
}
